import Alpine from 'alpinejs';

Alpine.data('navItem', () => ({
  events: {
    ['x-on:mouseenter']() {
      this.$dispatch('live-search:reset');
      this.$dispatch('header:pin');
      this.$dispatch('header:block');
    },
    ['x-on:mouseleave']() {
      this.$dispatch('header:unpin');
      this.$dispatch('header:unblock');
    },
  },
}));